import { useQuery } from '@tanstack/react-query';

import type { FollowUpTicketListItem } from 'src/types/followUp';
import { apiPaths } from 'src/services/api/apiPaths';
import HttpService from 'src/services/api/http';

import useFollowUpFilters from './useFollowUpFilters';

const useTicketListQuery = (
  page: number,
  search: string,
  ordering: string,
  enabled = true,
) => {
  const { followUpFilters, dateRange, orgUnit } = useFollowUpFilters();

  return useQuery<
    {
      results: FollowUpTicketListItem[];
      count: number;
    },
    string
  >({
    queryKey: [
      apiPaths.FOLLOW_UP.TICKETS.LIST,
      page,
      search,
      ordering,
      dateRange,
      orgUnit,
      followUpFilters,
    ],
    enabled,
    queryFn: ({ signal }) =>
      HttpService.get(
        apiPaths.FOLLOW_UP.TICKETS.LIST,
        {
          page,
          search,
          ordering:
            ordering === 'follow_up_owner'
              ? 'follow_up_owner__first_name, follow_up_owner__last_name'
              : ordering === '-follow_up_owner'
                ? '-follow_up_owner__first_name, -follow_up_owner__last_name'
                : ordering,
          orgUnit,
          ...dateRange,
          ...followUpFilters,
        },
        true,
        { signal },
      )
        .then((data) => Promise.resolve(data.data))
        .catch(({ response }) => {
          if (
            response.status >= 500 ||
            response.status === 424 ||
            response.status === 404 ||
            response.status === 400
          ) {
            return Promise.reject('somethingWentWrong');
          }
          if (Object.hasOwn(response.data, 'detail')) {
            return Promise.reject(String(response.data.detail));
          }
          return Promise.reject(String(response.data));
        }),
  });
};

export default useTicketListQuery;
